import GoogleMapLoader from './GoogleMapLoader.vue';

export { GoogleMapLoader };
export default GoogleMapLoader;
